(() => {
  const SELECTOR_ROOT = '[data-sc-ai-image-label]';
  const SELECTOR_TRIGGER = '[data-sc-ai-image-label-trigger]';
  const SELECTOR_TOOLTIP = '[data-sc-ai-image-label-tooltip]';
  const HOVER_MQ = '(hover: hover) and (pointer: fine)';

  let openRoot = null;

  const canHover = () =>
    typeof window.matchMedia === 'function' && window.matchMedia(HOVER_MQ).matches;

  const closeLabel = (root) => {
    if (!root) return;
    const trigger = root.querySelector(SELECTOR_TRIGGER);
    const tooltip = root.querySelector(SELECTOR_TOOLTIP);
    root.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (tooltip) tooltip.hidden = true;
    if (openRoot === root) openRoot = null;
  };

  const openLabel = (root) => {
    if (!root) return;
    if (openRoot && openRoot !== root) closeLabel(openRoot);
    const trigger = root.querySelector(SELECTOR_TRIGGER);
    const tooltip = root.querySelector(SELECTOR_TOOLTIP);
    root.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (tooltip) tooltip.hidden = false;
    openRoot = root;
  };

  const toggleLabel = (root) => {
    if (root.classList.contains('is-open')) {
      closeLabel(root);
    } else {
      openLabel(root);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(SELECTOR_TRIGGER);
      if (trigger) {
        const root = trigger.closest(SELECTOR_ROOT);
        if (!root) return;
        event.preventDefault();
        event.stopPropagation();
        // Desktop hover devices rely on hover; click still toggles for keyboard/touch hybrids
        toggleLabel(root);
        return;
      }

      if (openRoot && !event.target.closest(SELECTOR_ROOT)) {
        closeLabel(openRoot);
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openRoot) {
      const trigger = openRoot.querySelector(SELECTOR_TRIGGER);
      closeLabel(openRoot);
      if (trigger) trigger.focus();
    }
  });

  document.addEventListener('focusin', (event) => {
    const root = event.target.closest(SELECTOR_ROOT);
    if (root && event.target.closest(SELECTOR_TRIGGER)) {
      openLabel(root);
      return;
    }
    if (openRoot && (!root || root !== openRoot)) {
      closeLabel(openRoot);
    }
  });

  document.addEventListener(
    'pointerover',
    (event) => {
      if (!canHover()) return;
      const root = event.target.closest?.(SELECTOR_ROOT);
      if (!root || root.classList.contains('is-open')) return;
      openLabel(root);
    },
    true
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      if (!canHover()) return;
      const root = event.target.closest?.(SELECTOR_ROOT);
      if (!root) return;
      const related = event.relatedTarget;
      if (related && root.contains(related)) return;
      closeLabel(root);
    },
    true
  );
})();
